import { createFileRoute } from '@tanstack/react-router';
import UserEdit from '../../../features/management/users/user/edit';
import {
  createPermissionGuard,
  getPermissionSet,
  USER_MANAGEMENT_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/verwaltung/benutzer/$userId_/bearbeiten',
)({
  component: UserEdit,
  beforeLoad: createPermissionGuard(
    getPermissionSet(USER_MANAGEMENT_PERMISSIONS, 'EDIT'),
  ),
});

export const EditUserRoute = Route;
